<template>
  <div v-if="isShow" class="content-selection-wrapper">
    <div class="hd">
      选择展示内容
    </div>
    <div class="bd">
      <ul>
        <li
          v-for="(item, index) in options"
          :key="index"
          :class="{
            'flex-start': item.children && item.children.options.length > 2 && item.children.options.length <= 4
          }"
        >
          <div class="selection-item-label">
            {{ item.label }}
          </div>
          <template v-if="item.children && Array.isArray(item.children.options)">
            <div
              v-if="item.children.type === 'select' || item.children.options.length > 4"
              class="content-select after-bdr"
              @click="popPicker(item, $event)"
            >
              {{
                labelValue(
                  item.children.options,
                  contentValue[item.children.key]
                )
              }}
              <i class="icon-arow assert-b" />
            </div>
            <div
              v-else-if="item.children.type === 'radio' || item.children.options.length <= 4"
              class="content-checkbox"
            >
              <bxs-radio-group v-model="contentValue[item.children.key]">
                <bxs-radio
                  v-for="(op, idx) in item.children.options"
                  :key="idx"
                  :name="op.value"
                  :data-stat-id="item.stat"
                  :data-stat-ep="JSON.stringify({ value: op.value })"
                >
                  {{ op.label }}
                </bxs-radio>
              </bxs-radio-group>
            </div>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { isWeCom, isWeEnterprise, isMiniBankInsurance } from 'base/config'
import { buriedSubmit } from '@/common/js/common'
import { RadioGroup, Radio, Picker } from 'bxs-ui-vue'
Vue.use(Picker)

export default {
  name: 'ContentSelection',
  components: {
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup
  },
  props: {
    value: Object,
    options: Array
  },
  computed: {
    isShow () {
      const { options } = this
      return Array.isArray(options) && options.length
    },
    contentValue: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  },
  watch: {
    options: {
      handler(v) {
        if (!v || !v.length) return
        const idx = v.findIndex(item => item.label === '个人名片')
        if (idx < 0) return
        if (isWeCom || isWeEnterprise || isMiniBankInsurance) {
          this.options.splice(idx, 1)
        }
      },
      immediate: true
    }
  },
  methods: {
    popPicker ({ label, children, stat }, e) {
      if (
        /disabled/.test(e.target.className) ||
        !Array.isArray(children.options)
      ) {
        return
      }
      const vm = this
      const defaultValue = this.labelValue(
        children.options,
        vm.contentValue[children.key] || children.value
      )
      this.$picker({
        title: label && `选择${label}`,
        defaultValue: [defaultValue],
        pickerData: children.options,
        valueKey: 'label',
        callback (backInfo) {
          if (backInfo.type === 'confirm') {
            const val = children.options[backInfo.index].value
            vm.contentValue[children.key] = val
            buriedSubmit(stat, { value: val })
          }
        }
      })
    },
    labelValue (options, value) {
      if (!Array.isArray(options)) {
        return ''
      }
      const option = options.find(item => Array.isArray(value) ? value.indexOf(item.value) > -1 : item.value === value)
      return option && option.label
    }
  }
}
</script>

<style lang="postcss" scoped>
.content-selection-wrapper {
  background-color: #fff;
  color: #333;
  .hd {
    padding: 0.24rem 0.3rem;
    font-size: 0.34rem;
    font-weight: bold;
  }
  .selection-item-label {
    flex: 0 0 100px;
  }
  .bd {
    padding: 0.12rem 0.3rem 0.42rem;
    font-size: 0.28rem;
    li {
      display: flex;
      align-items: center;
      margin-bottom: 0.36rem;
      &.flex-start {
        align-items: flex-start;
        margin-bottom: 0.26rem;
      }
    }
  }
  .bx-radio-warp {
    padding: 0 10px;
  }
  .content-select {
    flex: 1;
    margin-left: 0.18rem;
    height: 0.62rem;
    padding: 0.11rem 0.74rem 0.11rem 0.18rem;
    font-size: 0.28rem;
    &.disabled {
      color: #c8c9cc;
      background-color: #ebedf0;
    }
    .icon-arow {
      position: absolute;
      right: 0.24rem;
      top: 50%;
      transform: translate(0, -50%);
      margin-top: -1px;
      &::after {
        border-color: #ccc;
      }
    }
  }
  .content-checkbox {
    flex: 1;
    > div {
      display: flex;
      flex-wrap: wrap;
    }
    .bx-radio-warp {
      overflow: hidden;
      display: flex;
      flex: 0 0 50%;
      align-items: center;
    }
  }
  .flex-start {
    .bx-radio-warp {
      margin-bottom: 10px;
    }
  }
}
</style>
<style>
.content-selection-wrapper {
  .bx-checkbox {
    .bx-checkbox-icon,
    .bx-checkbox-label {
      line-height: 18px;
    }
    .bx-checkbox-icon {
      .bx-icon {
        width: 18px;
        height: 18px;
      }
    }
  }
  .bx-radio-warp {
    .bx-radio-text {
      font-size: 0.26rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>